import axios from "axios";

const tokenMock = 656565;

export const apiMerchant = axios.create({
  baseURL: process.env.REACT_APP_API_MERCHANT,
});

export const apiBank = axios.create({
  baseURL: process.env.REACT_APP_API_BANK || process.env.REACT_APP_API_GATEWAY,
});

const setHeaders = (config) => {
  config.headers.Authorization = `Bearer ${tokenMock}`;
  return config;
};

const rejectPromise = (error) => Promise.reject(error);

apiMerchant.interceptors.request.use(setHeaders, rejectPromise);
apiBank.interceptors.request.use(setHeaders, rejectPromise);
